module.exports = __webpack_public_path__ + "img/agas_yes.e99f47ab.png";